/*! Grunt - v1.0.0 - 2018-05-28 1:39:45 */
/* StudioSteen Log - v1.0.2  Usage: log('message'/{}); */
function log() {
    'use strict';
    var messages = '';
    var objects = [];

    if (window.console) {
        for (var i = 0; i < arguments.length; i++) {
            var message = arguments[i];

            if (typeof message !== 'undefined') {
                if (typeof message === 'string' || typeof message === 'number') {
                    messages += ' ' + message;
                } else {
                    objects.push(message);
                }
            }
        }

        if (messages !== '') {
            var date = new Date();
            window.console.log(date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds() + '.' + date.getMilliseconds() + ': ' + messages);
        }
        if (objects.length > 0) {
            for (var j = 0; j < objects.length; j++) {
                window.console.log(objects[j]);
            }
        }
    }
}

/* Studio Steen preloadImages.js - v1.0.0
  Usage: preloadImages(array, function, 'debug');
  debug is optional
*/

function preloadImages(images, oncomplete, debug) {
    'use strict';
    var total = images.length,
        current = 0,
        d = (debug) ? true : false;

    function loadImage(current) {
        var img = new Image();
        if (d) {log('preloadImages: \t loading '+current+' / '+total);}
        img.onload = function() {
            current++;
            if (current === total) {
                if (d) {log('preloadImages: \t loading completed');}
                if (oncomplete && typeof(oncomplete) === 'function') {
                    oncomplete();
                } else {
                    return;
                }
            } else {
                loadImage(current);
            }
        };
        img.src = images[current].src;
    }

    loadImage(current);
}

$.fn.calendarPlugin = function (options) {
    'use strict';

    var _elem = $(this),  // instance to $('#selector')
        _this = this,     // instance to this plugin
        _modal = $('#calendar-modal'),
        _currentURL = window.location.href,
        _eventFilterUser = $('#filter-events-user'),
        _eventFilterProject = $('#filter-events-project');

    // custom variables
    var o = $.extend({

    }, options);

    _this.init = function() {
        $(document).on('click', 'button.delete-event', function() {
            var eventId = $(this).data('id');

            _this.deleteEventById(eventId);
        });

        $(document).on('click', '.open-event[data-event-id]', function() {
            var eventId = $(this).data('event-id');

            _this.EventClick(eventId);
        });

        _eventFilterUser.dropdown('setting', 'onChange', function(value) {
            _elem.fullCalendar('rerenderEvents');
        });

        _eventFilterProject.dropdown('setting', 'onChange', function(value) {
            _elem.fullCalendar('rerenderEvents');
        });

        _this.initCalendar();
    };

    _this.initCalendar = function() {
        _elem.fullCalendar({
            header: {
                left: 'prev,next today',
                center: 'title',
                right: 'month,agendaWeek,agendaDay'
            },
            //selectable: true,
            //selectHelper: true,
            //editable: true,
            //eventDurationEditable: true,
            slotDuration: '00:30:00',
            slotLabelFormat: 'H:mm',
            scrollTime: '07:00:00',
            timeFormat: 'H:mm',
            nowIndicator: true,
            displayEventEnd: {
                month: true,
                agendaWeek: true,
                "default": true
            },
            lang: 'nl',
            cache: true,
            defaultDate: new Date(),
            defaultView: 'agendaWeek',
            eventLimit: true, // allow "more" link when too many events
            eventSources: {
                url: _currentURL,
                type: 'POST',
                data: {
                    ajax: 1,
                    request_events: 1
                },
                error: function(data) {
                    alert('Er is iets fout gegaan bij het ophalen van de gegevens. Mocht dit vaker gebeuren neem dan contact op met Stukje Design. Tel: 058 201 19 97');
                }
            },
            eventRender: function eventRender( event )
            {
                if (_eventFilterProject.length > 0)
                    return ['all', event.user_id].indexOf(_eventFilterUser.dropdown('get value')) >= 0 && ['all', event.project_id].indexOf(_eventFilterProject.dropdown('get value')) >= 0;
                else
                    return ['all', event.user_id].indexOf(_eventFilterUser.dropdown('get value')) >= 0;
            },
            eventClick: function(calEvent)
            {
                // ajax call according to event ID
                var eventId = calEvent.id;

                _this.EventClick(eventId);
            },
            //eventResize: function(data)
            //{
            //    var eventId = data.id;
            //    var eventStart = data.start.format();
            //    var eventEnd = data.end.format();
            //
            //    _this.editEvent(eventId, eventStart, eventEnd);
            //},
            eventDrop: function(event)
            {
                var eventId = event.id;
                var eventStart = event.start.format();
                var eventEnd = event.end.format();

                _this.editEvent(eventId, eventStart, eventEnd);
            }
        });
    };

    _this.deleteEventById = function(eventId)
    {
        $('#confirmation-modal').modal({
            observeChanges:true,
            allowMultiple: true,
            onShow: function() {
                /*
                    Hack for bad positioning
                 */
                setTimeout(function () {
                    $('#confirmation-modal').modal('refresh');
                }, 1);
            },
            onApprove: function() {
                $.ajax(_currentURL, { data: {ajax: 1, deleteEvent: 1, eventId: eventId},
                    type: 'POST',
                    error: function(data) {
                        console.log(data);
                    },
                    success: function(data) {
                        var response = jQuery.parseJSON(data);

                        if (response.status == 'success')
                        {
                            _modal.modal('hide');
                            _elem.fullCalendar('removeEvents', eventId);
                        }

                        new Messenger().post({
                            message: response.message,
                            hideAfter: 3.5,
                            type: response.status,
                            showCloseButton: true
                        });
                    }
                });
            }
        }).modal('show');
    };

    _this.editEvent = function(eventId, eventStart, eventEnd)
    {
        $.ajax(_currentURL, { data: {ajax: 1, eventResize: 1, eventId: eventId, eventStart: eventStart, eventEnd: eventEnd},
            type: 'POST',
            error: function(data) {
                console.log(data);
            },
            success: function(data) {
                var response = jQuery.parseJSON(data);

                new Messenger().post({
                    message: response.message,
                    hideAfter: 3.5,
                    type: response.status,
                    showCloseButton: true
                });
            }
        });
    };

    _this.EventClick = function(eventId) {
        $.ajax(_currentURL, { data: {ajax: 1, eventClick: 1, eventId: eventId},
            type: 'POST',
            error: function(data) {
                console.log(data);
            },
            success: function(data) {
                var html = jQuery.parseJSON(data);

                _modal.html(html).promise().done(function() {
                    _modal.modal({
                        observeChanges:true,
                        allowMultiple: true,
                        onShow: function() {
                            /*
                                Hack for bad positioning
                             */
                            setTimeout(function () {
                                _modal.modal('refresh');
                            }, 1);
                        }
                    }).modal('show');
                });
            }
        });
    };

    _this.init();
};






$.fn.datatableAddition = function (options) {
    'use strict';

    var _elem = $(this),  // instance to $('#selector')
        _this = this,     // instance to this plugin
        _checkAllObj = $('input[type="checkbox"].check-all');

    // custom variables
    var o = $.extend({

    }, options);

    _this.init = function() {
        // check all checkboxes in current view
        _checkAllObj.on('click', function() {
            var checked = $(this).prop('checked');

            _this.toggleCheckAll(checked);
        });

        // check to turn on or off the visible objects
        $(document).on('click', '.check-col input[type="checkbox"]', function() {
            if (_this.watchChecks() >= 1)
            {
                _this.toggleVisibleObjects('show');
            }
            else
            {
                _this.toggleVisibleObjects('hide');
            }
        });

        // Move all items to trashcan
        $('#material-actions .trash').on('click', function() {
            var objArray = _this.GetCheckedRows();

            _this.MoveSelectedItems(objArray, 'moveToTrash');
        });

        // Move all items from trashcan
        $('#material-actions .restore').on('click', function() {
            var objArray = _this.GetCheckedRows();

            _this.MoveSelectedItems(objArray, 'restore');
        });
    };

    // Ajax call to do something with all selected items based on action given
    _this.MoveSelectedItems = function(objArray, action) {
        var postUrl = _elem.find('table').data('url');

        $('#confirmation-modal').modal({
            onShow: function() {
                /*
                    Hack for bad positioning
                 */
                setTimeout(function () {
                    $('#confirmation-modal').modal('refresh');
                }, 1);
            },
            onApprove: function() {
                $.ajax(postUrl, { data: {ajax: 1, action: action, objArray: objArray},
                    type: 'POST',
                    error: function(data) {
                        console.log(data);
                    },
                    success: function(data) {
                        console.log(data);

                        var response = jQuery.parseJSON(data);

                        if (response.status == 'success')
                        {
                            _elem.find('tbody td.check-col input[type="checkbox"]:checked').each(function() {
                                $(this).parents('tr').fadeOut(400, function() {
                                    $(this).remove();
                                });
                            });

                            var messenger = new Messenger().post({
                                message: response.message,
                                hideAfter: 3.5,
                                type: 'success',
                                showCloseButton: true
                            });
                        }
                    }
                });
            }
        }).modal('show');
    };

    // Get all checked items in current list
    // returns array with all values from checkboxes (basically id's from items)
    _this.GetCheckedRows = function() {
        var objArray = [];

        _elem.find('tbody td.check-col input[type="checkbox"]:checked').each(function() {
            var thisId = $(this).val();

            objArray.push(thisId);
        });

        return objArray;
    };

    // watch and returns amount of checkboxes count
    _this.watchChecks = function() {
        var countChecks = _elem.find('input[type="checkbox"]:checked').length;

        return countChecks;
    };

    // toggles objects which have to become visible if at least one checkbox is checked
    // usage:
    // <div class="visible-on-check [is-visible/not-visible]">
    _this.toggleVisibleObjects = function(visibility) {
        if (visibility == 'show')
            $('.visible-on-check').removeClass('not-visible').addClass('is-visible');
        else
            $('.visible-on-check').removeClass('is-visible').addClass('not-visible');
    };

    // toggle all checkboxes
    _this.toggleCheckAll = function(checked) {
        _elem.find('table tbody .checkbox-wrapper input[type="checkbox"]').each(function() {
            if (checked === true)
            {
                $(this).prop('checked', true);
            }
            else
            {
                $(this).prop('checked', false);
            }
        });
    };

    _this.init();
};
(function () {
    var ids;
    var preventRequest = true;
    $('input[name=group_id]').on('change', function() {
        $.post('', {
            ajax: 1,
            action: 'get_permissions_group',
            group_id: $(this).val()
        }, function (response) {
            ids = JSON.parse(response);
            $('#permission_group').show();
            setValues();
        });
    });

    $('input[name=permission_group]').on('change', function () {
        // Get ID
        var $this = $(this);
        var id;

        switch ($this.val()) {
            case 'read':
                id = ids.read;
                break;
            case 'write':
                id = ids.write;
                break;
            default:
                id = null;
        }

        if(preventRequest === false) {
            $.post('', {
                ajax: 1,
                action: 'update_permission_group',
                permission_group: $('input[name=group_id]').val(),
                newID: id,
                oldID: ids.selected
            }, function(response) {
                response = JSON.parse(response);
                if(response.success) {
                    Messenger().post({
                        message: 'Wijziging opgeslagen!',
                        hideAfter: 3.5,
                        type: 'success',
                        showCloseButton: true
                    });

                    updatePermissionTable();
                    // update IDs
                    $.post('', {
                        ajax: 1,
                        action: 'get_permissions_group',
                        group_id: $('input[name=group_id]').val()
                    }, function (response) {
                        ids = JSON.parse(response);
                        console.log(response);
                    });

                } else {
                    Messenger().post({
                        message: 'Oeps, er ging iets mis!',
                        hideAfter: 3.5,
                        type: 'error',
                        showCloseButton: true
                    });
                }
            });
        }
        preventRequest = false;
    });

    /**
     * Set values to the correct <select> value
     */
    function setValues() {
        preventRequest = true;
        if(ids.selected === null) {
            // Set 'none' option as active
            $('input[name=permission_group]').val('none').change();
        } else if(ids.selected === ids.read) {
            // Set read option as active
            $('input[name=permission_group]').val('read').change();
        } else if(ids.selected === ids.write) {
            // Set write option as active
            $('input[name=permission_group]').val('write').change();
        }
    }

    function updatePermissionTable() {
        $.post('', {
            ajax: 1,
            action: 'permission_table'
        }, function(response) {
            $('#permission-table').html(response);
            shortcuts();
        });
    }

    /**
     * Set shortcuts, so the user can click on a group in the permission table and it will selected that one
     */
    function shortcuts() {
        // Reset shortcuts
        $('.permission-name-shortcut')
            .off('click')
            .on('click', function(e) {
                // Set group ID
                preventRequest = true;
                $('input[name=group_id]').val($(this).data('id')).change();
            });
    }

    shortcuts();

})();
$.fn.navigation = function (options) {
    'use strict';

    var _elem = $(this),  // instance to $('#selector')
        _this = this,     // instance to this plugin
        _toggleNav = $('.toggle-nav-mobile');

    // custom variables
    var o = $.extend({

    }, options);


    _this.init = function() {
        $('body').append('<div id="nav-overlay" class="overlay-hidden"></div>');

        _toggleNav.on('click', function() {
            _this.toggleNavMobile();
        });

        $(document).on('click', '#nav-overlay', function() {
            _this.toggleNavMobile();
        });

        _elem.find('.toggle-sub').on('click', function() {
            _this.toggleSubNav($(this));
        });
    };

    _this.toggleSubNav = function(elem) {
        var parentContainer = elem.parents('li');
        var subnav = parentContainer.find('ul.sub-navigation');

        if (!subnav.hasClass('sub-open'))
        {
            subnav.addClass('sub-open').slideDown(300);
            parentContainer.addClass('sub-open');
            return false;
        }
        else
        {
            subnav.removeClass('sub-open').slideUp(300);
            parentContainer.removeClass('sub-open');
            return false;
        }
    };

    _this.toggleNavMobile = function() {
        if (_elem.hasClass('mobile-hidden'))
        {
            _elem.removeClass('mobile-hidden').addClass('mobile-visible');
            _toggleNav.removeClass('nav-hidden').addClass('nav-visible');
            $('#nav-overlay').addClass('overlay-visible').removeClass('overlay-hidden');
            return false;
        }
        else
        {
            _elem.addClass('mobile-hidden').removeClass('mobile-visible');
            _toggleNav.addClass('nav-hidden').removeClass('nav-visible');
            $('#nav-overlay').addClass('overlay-hidden').removeClass('overlay-visible');
            return false;
        }
    };

    _this.init();
};
(function () {
    var $overview = $( ".overview-multi" );
    if($overview.length > 0) {
        var $parentSelector = $overview.find('input[name=parent_id]');
        $parentSelector.on('change', function () {
            window.location = '/_cms/multipages/' + $(this).val();
        });
    }
})();
$.fn.searchNotes = function (options) {
    'use strict';

    var _elem = $(this),  // instance to $('#selector')
        _this = this,     // instance to this plugin
        _notes = $(this).find('.notes-wrapper');

    // custom variables
    var o = $.extend({

    }, options);


    _this.init = function() {
        _elem.find('.search-notes-wrapper input[type="text"]').on('keyup', function() {
            var $value = $(this).val();

            _this.searchNotes($value);
        });
    };

    _this.searchNotes = function($value) {
        if ($value !== '')
        {
            _notes.find('.note').addClass('hidden');

            _notes.find('.note').each(function() {
                var $this = $(this);
                var $message = $this.find('.note-information').html();
                $message = $message.replace(/(<([^>]+)>)/ig, '');

                console.log($message);

                if ($message.toLowerCase().indexOf($value.toLowerCase()) !== -1)
                {
                    $this.addClass('visible').removeClass('hidden');
                }
            });
        }
        else
        {
            _notes.find('.note').removeClass('hidden');
        }
    };

    _this.init();
};
$.fn.Timer = function (options) {
    'use strict';

    var _elem = $(this),  // instance to $('#selector')
        _this = this,     // instance to this plugin
        _startTimers = $('.start-timer'),
        _interval = '',
        _timer = $('#header .project-timer h4 .timer');

    // custom variables
    var o = $.extend({

    }, options);


    _this.init = function() {
        // start timer
        _startTimers.dropdown('setting', 'onChange', function(value, text) {
            var projectId = $(this).data('project-id');
            _this.startTimer(value, text, projectId);
        });

        // stop timer
        $(document).on('click', '.stop-timer', function() {
            _this.stopTimer();
        });

        // run timer if on page load timer already shown
        if (_timer.length > 0)
            _this.runTimer();
    };

    _this.stopTimer = function() {
        var projectName = _timer.data('project-name');
        var subject     = _timer.data('subject');

        $('#stop-timer-modal .header').html(projectName + ' - ' + subject);

        $('#stop-timer-modal').modal({
            onShow: function() {
                /*
                    Hack for bad positioning
                 */
                setTimeout(function () {
                    $('#stop-timer-modal').modal('refresh');
                }, 1);

                // create ckeditor if hasnt created yet
                if ($('.cke_editor_project_description').length === 0)
                {
                    CKEDITOR.replace('project_description');
                    CKEDITOR.on('instanceReady', function() {
                        $('#stop-timer-modal').modal('refresh');
                    });
                }
            },
            onApprove: function() {
                var ckeditorHTML = CKEDITOR.instances.project_description.getData();

                $.ajax('/_cms/crm/view/0/projects/', { data: {ajax: 1, stopTimer: 1, description: ckeditorHTML},
                    type: 'POST',
                    error: function(data) {
                        console.log(data);
                    },
                    success: function(data) {
                        var response = jQuery.parseJSON(data);

                        if (response.status == 'success')
                        {
                            _startTimers.addClass('disabled');

                            var projectTimer = $('#header .project-timer');

                            // clear ckeditor values
                            CKEDITOR.instances.project_description.setData('');

                            // hide timer
                            projectTimer.fadeOut(600, function() {
                                projectTimer.html('');
                                clearInterval(_interval);
                                _startTimers.removeClass('disabled');
                            });

                            new Messenger().post({
                                message: response.message,
                                hideAfter: 3.5,
                                type: 'success',
                                showCloseButton: true
                            });
                        }
                        else if (response.status == 'failed')
                        {
                            new Messenger().post({
                                message: response.message,
                                hideAfter: 3.5,
                                type: 'error',
                                showCloseButton: true
                            });
                        }
                    }
                });
            }
        }).modal('show');
    };

    _this.runTimer = function() {
        _timer = $('#header .project-timer h4 .timer');

        var seconds     = _timer.data('seconds');
        var minutes     = _timer.data('minutes');
        var hours       = _timer.data('hours');

        _interval = setInterval(function() {
            seconds++;

            if (seconds > 59)
            {
                seconds = 0;
                minutes++;
            }

            if (minutes > 59)
            {
                minutes = 0;
                hours++;
            }

            // leading zeros
            if (seconds.toString().length == 1)
                seconds = '0' + seconds;

            if (minutes.toString().length == 1)
                minutes = '0' + minutes;

            if (hours.toString().length == 1)
                hours = '0' + hours;

            _timer.html(hours + ':' + minutes + ':' + seconds);
        }, 1000);
    };

    _this.startTimer = function(value, text, projectId) {
        $.ajax('', { data: {ajax: 1, value: value, text: text, projectId: projectId},
            type: 'POST',
            error: function(data) {
                console.log(data);
            },
            success: function(data) {
                var response = jQuery.parseJSON(data);

                if (response.status == 'success')
                {
                    _startTimers.addClass('disabled');

                    var projectTimer = $('#header .project-timer');

                    // show timer
                    projectTimer.hide()
                        .prepend('<h4>'+ response.projectName +' - <span class="timer" data-project-name="'+ response.projectName +'" data-subject="'+ text +'" data-hours="00" data-minutes="00" data-seconds="00">00:00:00</span></h4>')
                        .append('<button class="stop-timer btn btn-red" title="Stop timer"><i class="fa fa-stop-circle-o"></i></button>')
                        .fadeIn(600);

                    _this.runTimer();

                    new Messenger().post({
                        message: response.message,
                        hideAfter: 3.5,
                        type: 'success',
                        showCloseButton: true
                    });
                }
                else if (response.status == 'failed')
                {
                    new Messenger().post({
                        message: response.message,
                        hideAfter: 3.5,
                        type: 'error',
                        showCloseButton: true
                    });
                }
            }
        });
    };

    _this.init();
};
$(function () {
    /* global Modernizr:true */

    var _this = this,
        _body = $('body');

    /*
        INIT
    */
    _this.init = function() {

        $('#language-selector > a').on('click', function(e) {
            e.preventDefault();
            console.log('reached');
            $.post('', {
                lang: $(this).data('lang')
            }, function() {
                window.location = '/_cms/';
            });
        });


        // initialize messenger options for short messages bottom right corner
        Messenger.options = {
            extraClasses: 'messenger-fixed messenger-on-bottom messenger-on-right',
            theme: 'flat',
            parentLocations: ['body'],
            maxMessages: 5
        };

        // initialize lazy load google maps (iframe, or any other iframe)
        $('.iframe .image-wrapper').on('click', function() {
            var source = $(this).data('source');
            $(this).siblings('iframe').attr('src', source);
            $(this).fadeOut(500);
        });

        // create datepickers
        $('input.form-date').each(function() {
            var that = $(this);
            var format = $(this).data('format');

            that.datetimepicker({
                format: format,
                locale: 'nl',
                showTodayButton: false,
                useCurrent: false,
                viewMode: 'days',
                showClose: true,
                showClear: true,
                icons: {
                    time: 'fa fa-clock-o',
                    date: 'fa fa-calendar',
                    up: 'fa fa-arrow-up',
                    down: 'fa fa-arrow-down',
                    previous: 'fa fa-arrow-left',
                    next: 'fa fa-arrow-right',
                    today: 'fa fa-hand-o-down',
                    clear: 'fa fa-trash-o',
                    close: 'fa fa-times'
                }
            });
        });

        if ($('#start_time').length > 0 && $('#end_time').length > 0)
        {
            var dateStart   = $('#start_time');
            var dateEnd     = $('#end_time');
            var format      = dateEnd.data('format');
            var date        = '';

            if (!dateStart.val())
                dateStart.data('DateTimePicker').date(moment());

            dateStart.on("dp.change", function (e) {
                dateEnd.data("DateTimePicker").minDate(e.date);
                date = e.date;
            });

            dateEnd.on("dp.change", function (e) {
                dateStart.data("DateTimePicker").maxDate(e.date);
            });

            dateEnd.on('focus', function() {
                if (!$(this).val())
                {
                    if (dateStart.val())
                    {
                        console.log(format);
                        dateEnd.val(moment(dateStart.val(), format).add('1', 'hour').format(format));
                    }
                }
            });
        }

        // create datatables
        $('table.datatable').DataTable({
            "oLanguage" : {
                "sSearch": "Zoeken:",
                "sSearchPlaceholder": 'Type hier uw zoekwoorden',
                "sLengthMenu": 'Aantal resultaten: <select class="ui dropdown">'+
                    '<option value="10">10</option>'+
                    '<option value="25">25</option>'+
                    '<option value="50">50</option>'+
                    '<option value="100">100</option>'+
                    '</select>',
                "sInfoEmpty": "Geen resultaten gevonden",
                "sZeroRecords": "Geen resultaten gevonden.",
                "sLoadingRecords": "EÃ©n moment geduld - gegevens worden geladen.",
                "sInfo": "_START_ tot _END_ van _TOTAL_ gevonden resultaten",
                "sInfoFiltered": " - gefilterd van _MAX_ resultaten",
                "oPaginate": {
                    "sPrevious": "<i class='fa fa-angle-double-left'></i>",
                    "sNext": "<i class='fa fa-angle-double-right'></i>"
                }
            },
            "dom": "<'data-top-wrapper'lf>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-md-5'i><'col-md-7'p>>",
            "aoColumnDefs": [{
                "aTargets": 'no-sort',
                "bSortable": false
            }],
            "pageLength": 25
        });

        // Initialize tabledrag for navigation hierarchy
        // -- /js/vendor/jquery.tabledrag.js
        if ($('table.tabledrag').length >= 0) {
            var table_drag;
            var tabledrag_options = {
                group: {
                    fieldClass: 'row-depth',
                    depthLimit: 1
                },
                callback: function() {
                    var data_array = [];
                    $('tr.draggable').each(function() {
                        var page_id = $(this).children('td').children('input.page-id').attr('value');
                        var depth = $(this).children('td').children('input.row-depth').attr('value');
                        var sort = $(this).find('select.row-sort').find('option:selected').attr('value');
                        var parent = $(this).find('select.row-parent').find('option:selected').attr('value');

                        // create an object array
                        data_array.push({
                            page_id: page_id,
                            sort: sort,
                            parent: parent
                        });
                    });

                    var post_url = $('table.tabledrag').data('url');
                    var data_table = $('table.tabledrag').data('table');

                    // create json array from object array
                    data_array = JSON.stringify(data_array);

                    $.ajax(post_url, { data: {ajax: 1, reorder: 1, data_table: data_table, data: data_array},
                        type: 'POST',
                        error: function(data) {
                            console.log(data);
                        },
                        success: function(data) {
                            var response = jQuery.parseJSON(data);

                            Messenger().post({
                                message: response.message,
                                hideAfter: 3.5,
                                type: 'success',
                                showCloseButton: true
                            });
                        }
                    });
                }
            };

            table_drag = $('.tabledrag').tableDrag(tabledrag_options);
        }


        // create slimscroll from nav
        $('#navigation .outer-nav').slimScroll({
            allowPageScroll: false,
            size: '2px',
            height: 'calc(100% - 55px)',
            width: '100%',
            railVisible: true,
            railColor: '#0c1d2d',
            color: '#426686'
        });


        /**
         *  INIT PLUGINS!
         */
        // dropdown is initialized in dropdown.min.js
        $('#navigation').navigation();
        $('#information-table').datatableAddition();
        $('#calendar').calendarPlugin();
        $('[data-toggle="tooltip"]').tooltip();
        $('#notes').searchNotes();
        $('#projects').Timer();
        $('input.color-picker').minicolors({
            position: 'top left'
        });

        /*
         * Check if form creator class should be initialized
         * */
        if($('.formcreator-new-fields').length > 0)
            $('.formcreator-new-fields').formcreator();

        // init file uploader (single resize & crop)
        $('.dropzone').each(function() {
            $this = $(this);

            $this.html5imageupload();
        });

        // init multi file uploader
        $('.html5fileupload').each(function() {
            $this = $(this);

            $this.html5fileupload({

            });
        });

        // sort html5 file upload images
        $('.html5fileupload').sortable({
            items: '> .file',
            stop: function(event, ui)
            {
                // create array from id's in order
                var sortedIDs = $('.html5fileupload').sortable('toArray');
                var JSONids = JSON.stringify(sortedIDs);
                var table = $('.html5fileupload').data('table');

                $.ajax('', { data: {ajax: 1, reorderImages: 1, data: JSONids, table: table},
                    type: 'POST',
                    error: function(data) {
                        console.log(data);
                    },
                    success: function(data) {
                        var response = jQuery.parseJSON(data);

                        if (response.status == 'success')
                        {
                            Messenger().post({
                                message: response.message,
                                hideAfter: 3.5,
                                type: 'success',
                                showCloseButton: true
                            });
                        }
                        else
                        {
                            Messenger().post({
                                message: response.message,
                                hideAfter: 3.5,
                                type: 'error',
                                showCloseButton: true
                            });
                        }
                    }
                });
            }
        });

        // sort html5 file upload images
        $('.html5fileupload2').sortable({
            items: '> .file',
            stop: function(event, ui)
            {
                // create array from id's in order
                var sortedIDs = $('.html5fileupload2').sortable('toArray');
                var JSONids = JSON.stringify(sortedIDs);
                var table = $('.html5fileupload2').data('table');

                $.ajax('', { data: {ajax: 1, reorderImages: 1, data: JSONids, table: table},
                    type: 'POST',
                    error: function(data) {
                        console.log(data);
                    },
                    success: function(data) {
                        var response = jQuery.parseJSON(data);

                        if (response.status == 'success')
                        {
                            Messenger().post({
                                message: response.message,
                                hideAfter: 3.5,
                                type: 'success',
                                showCloseButton: true
                            });
                        }
                        else
                        {
                            Messenger().post({
                                message: response.message,
                                hideAfter: 3.5,
                                type: 'error',
                                showCloseButton: true
                            });
                        }
                    }
                });
            }
        });

        // Example:
        // <a href="#" title="" class="rel-external">link</a>
        $('.rel-external, .external').on('click', function(e) {
            e.preventDefault();
            var url = $(this).attr('href');
            window.open(url, '_blank');
        });

    }; // einde van init

    _this.init();

});